import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is the Overlander 4 road-legal in Australia?",
    a: "Yes — the Overlander 4 is a Class 3 medical mobility device. It is permitted on Australian footpaths and roads under standard mobility-scooter rules (max 10 km/h on footpaths), AND it is engineered for serious off-road use on private land, station tracks, beaches, fire trails and 4WD park trails. State-by-state rules apply on public roads — Overlander Mobility will walk you through them on your trial.",
  },
  {
    q: "Who is the Australian distributor?",
    a: "TerrainHopper's authorised Australian distributor is Overlander Mobility, based in Geelong, Victoria, with trials available nationally. Contact: info@overlandermobility.com.au.",
  },
  {
    q: "What if a motor or circuit fails out in the bush?",
    a: "The Overlander 4 has two completely separate electrical systems — one for the front motors and one for the rear — plus motor overheat protection. If one circuit fails you keep moving on the other. This is a key reason it's trusted in remote conditions.",
  },
  {
    q: "How far will it go on a charge?",
    a: "On the standard 24 V / 100 Ah lithium pack, expect roughly 37 km per charge in mixed terrain. Upgrade to 24 V / 150 Ah for around 55 km, or 24 V / 200 Ah for around 72 km — figures vary with rider weight, gradient and surface.",
  },
  {
    q: "What are the standard inclusions?",
    a: "All-round independent suspension, 4 × 750 W motors, 24 V / 100 Ah lithium battery, 10 km/h speed, side roll bar (lifts left or right), Exmoor Trim seat, lap belt, mirrors, LED front and rear lights, indicators, manual steering, choice of smooth or knobbly tyres, security key, and a choice of six standard colours: Red, Lemon Yellow, Lime Green, Kawasaki Green, Orange or Gloss Black.",
  },
  {
    q: "Can it really go in water and on the beach?",
    a: "Yes. Motors and components are waterproof up to the battery box, so creek crossings and wet beach driving are well within design spec. As with any vehicle on soft sand, drop tyre pressure and avoid prolonged submersion.",
  },
  {
    q: "Can I book a test drive in Australia?",
    a: "Absolutely. Overlander Mobility offers in-person trials starting from $299, anywhere in Victoria. Interstate trials are quoted on request. Use the form above and the team will contact you within three business days to organise the closest trial to you.",
  },
  {
    q: "Is funding (NDIS) available?",
    a: "The Overlander 4 is a Class 3 medical mobility device. NDIS, DVA and similar funding pathways may apply depending on your plan and assessment — Overlander Mobility's team can walk you through the process and provide documentation for your OT or plan manager.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
            FAQ
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight font-bold leading-[1.05]">
            Straight <br /> answers.
          </h2>
          <p className="mt-6 text-base text-muted-foreground leading-relaxed">
            Still curious? Drop a question into the trial form above — a real person from
            Overlander Mobility in Geelong will reply.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} data-testid={`faq-item-${i}`} className="border-border">
                <AccordionTrigger className="text-left font-display text-base md:text-lg uppercase tracking-tight font-semibold py-5 hover:no-underline hover:text-primary">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
